






import {PredictEstimateState as EstimateState} from '@/model/api';
import PredictEstimate from '@/model/estimates/PredictEstimate';
import {HttpClient} from '@/model/http';
import {NotSubmittedParameters, OfflineManager, StagedParameters} from '@/model/offline';
import {StoredParameters} from '@/model/offline/storage/StoredParameters';
import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import EstimateForm from './common/EstimateForm.vue';
import PhotosSegment from './common/PhotosSegment.vue';
import {LocationSegment, ParametersSegment, SegmentConfiguration} from './common/segments';

@Component({components: {EstimateForm}})
export default class PredictEstimateForm extends Vue {

  @Prop({type: Object, required: true})
  public readonly estimate: EstimateState;

  @Provide()
  public readonly notSubmittedParameters: NotSubmittedParameters = new NotSubmittedParameters(
      new StoredParameters(
          this.estimate.id,
          NotSubmittedParameters.STORAGE_KEY,
      ),
  );

  @Provide()
  public readonly model = new PredictEstimate(this.estimate, new HttpClient());

  @Provide()
  public readonly offlineManager: OfflineManager<EstimateState> = new OfflineManager<EstimateState>(
      new StagedParameters(
          new StoredParameters(
              this.estimate.id,
              StagedParameters.STORAGE_KEY,
          ),
      ),
      this.model,
  );

  public createSegmentConfiguration(estimate: EstimateState): SegmentConfiguration[] {
    return [
      {
        label: this.$tc('form.segments.location'),
        path: '/adresa',
        component: LocationSegment,
        props: {defaultValue: estimate.location},
      },
      ...estimate.segments.map(segment => ({
        label: segment.label,
        path: '/' + segment.path,
        component: ParametersSegment,
        props: {
          parameters: Object.fromEntries(
              Object.entries(estimate.parameters)
                  .filter(([parameterName]) => segment.parameterNames.includes(parameterName)),
          ),
          stagedParameters: this.offlineManager.stagedParameters,
          notSubmittedParameters: this.notSubmittedParameters,
        },
      })),
      {
        label: this.$tc('form.segments.photos'),
        path: '/fotografie',
        component: PhotosSegment,
        props: {photos: estimate.photos, estimate},
      },
    ];
  }
}
